const TICKER_ITEMS = [
  '🇴🇲 Oman Based',
  '🌍 GCC Supply',
  'Bulk Ready',
  '500+ Clients',
  '10M+ Gloves Supplied',
  '10+ Countries',
  '24hr Response',
  '🇴🇲 Oman Based',
  '🌍 GCC Supply',
  'Bulk Ready',
  '500+ Clients',
  '10M+ Gloves Supplied',
  '10+ Countries',
  '24hr Response',
];

export default function ScrollingTicker() {
  return (
    <div className="bg-navy py-3 overflow-hidden border-y border-navy-dark">
      <div className="ticker-track inline-flex gap-8">
        {TICKER_ITEMS.map((item, i) => (
          <span
            key={i}
            className="text-white/90 text-sm font-heading font-semibold flex items-center gap-2 shrink-0"
            dangerouslySetInnerHTML={{ __html: `${item} <span class="text-brand-green mx-2">◆</span>` }}
          />
        ))}
      </div>
    </div>
  );
}
